



















































































































import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import ColumnHeaderTable from '../components/common/Table/ColumnHeaderTable.vue';
import RowHeaderTable from '../components/common/Table/RowHeaderTable.vue';
import { LabelsetType } from '../interfaces/types/Labelset';
import { axiosApiInstance, getLabelsetById } from '../utils/axiosInstances';
import { flattenJSONSchema } from '../utils/flattenJson';

export default Vue.extend({
  components: {
    GNB,
    ColumnHeaderTable,
    RowHeaderTable,
  },
  data(): {
    datasetInfo: any;
    labelsetInfo: Partial<LabelsetType>;
    labelSchemaInfo: any;
  } {
    return {
      datasetInfo: {
        requirement: {
          resolution: {
            width: 0,
            height: 0,
          },
          file_size: 0,
        },
      },
      labelsetInfo: {},
      labelSchemaInfo: {},
    };
  },
  async created() {
    let result = await axiosApiInstance.get(
      `/api/v1/datasets/${this.$route.params.datasetId}`,
    );
    this.datasetInfo = result.data.result;

    if (this.isLabelsetExists) {
      const labelset = await getLabelsetById(this.$route.params.labelsetId);
      this.labelsetInfo = labelset;

      this.labelSchemaInfo = this.parseJSONtoArray(
        flattenJSONSchema(labelset.labelSchema),
      );
    }
  },
  methods: {
    parseJSONtoArray(labelsetJsonData: any) {
      const labelSchema: any = [];

      Object.keys(labelsetJsonData).forEach((key) => {
        let newLabelsetRow: any = {};
        newLabelsetRow['name'] = key;
        newLabelsetRow['type'] = labelsetJsonData[key].type;
        const { ['type']: _, ...labelsetRules } = labelsetJsonData[key];
        newLabelsetRow['rules'] = labelsetRules;
        labelSchema.push(newLabelsetRow);
      });

      return labelSchema;
    },
  },
  computed: {
    isLabelsetExists(): boolean {
      return this.$route.params.labelsetId !== undefined;
    },
    labelsetParsingMethod(): string {
      if (this.labelsetInfo.parsingRule === undefined) {
        return '기타';
      }
      if (this.labelsetInfo.parsingRule.labelType === 'filename') {
        return '파일명';
      } else if (this.labelsetInfo.parsingRule.labelType === 'directory') {
        return '파일 디렉토리';
      } else if (this.labelsetInfo.parsingRule.labelType === 'csv') {
        return 'CSV';
      } else if (this.labelsetInfo.parsingRule.labelType === 'singlejson') {
        return 'JSON : Data = N : M 방식 JSON 라벨링';
      } else if (this.labelsetInfo.parsingRule.labelType === 'multijson') {
        return 'JSON : Data = 1 : 1 방식 JSON 라벨링';
      } else {
        return '기타';
      }
    },
    labelsetSeparatorInfo(): string {
      if (this.labelsetInfo.parsingRule === undefined) {
        return '';
      }

      if (this.labelsetInfo.parsingRule.labelType === 'filename') {
        return this.labelsetInfo.parsingRule.seperator.join(', ');
      }
      return '';
    },
  },
});
